const getMarkerColor = (office, classNames) => {
  const { rating, status } = office;

  if (status === 'CLOSE') {
    return classNames.closed;
  }

  if (!rating) {
    return '';
  }

  if (rating > 75) {
    return classNames.happy;
  }

  if (rating > 50) {
    return classNames.indifferent;
  }

  return classNames.sad;
};

const getMetroStation = (address, undergrounds) => {
  const metroLocations = address?.metroLocations;
  let metroStationId = metroLocations?.metroStationId;

  if (!metroStationId && metroLocations) {
    metroStationId = metroLocations.sort((a, b) => {
      if (a.distance > b.distance) {
        return 1;
      }
      if (a.distance < b.distance) {
        return -1;
      }
      return 0;
    })[0]?.metroStationId;
  }

  const metroStation = undergrounds.filter((item) =>
    item.ids.includes(metroStationId)
  )[0]?.name;

  if (metroStation) {
    return metroStation;
  }

  return null;
};

const getOfficesMarkers = (classNames, offices, undergrounds, officeId) =>
  offices
    .filter((office) => !officeId || office.id === officeId)
    .map((office) => {
      const { id, address, name, replacementOffice } = office;
      const { latitude, longitude } = address;

      const metroStation = getMetroStation(address, undergrounds);

      const officeStatus = office.status;

      const className = getMarkerColor(office, classNames);

      return {
        latitude,
        longitude,
        id,
        className,
        metroStation,
        name,
        address,
        officeStatus,
        replacementOffice,
      };
    });

export default getOfficesMarkers;
